// Configuración global de SEO del sitio.
// Cambia aquí el dominio, nombre de marca, textos por defecto y redes
// sociales para que se reflejen en todo el sitio (meta tags, canonical,
// Open Graph, Twitter Cards y JSON-LD).

export const seoConfig = {
  // Dominio final de producción (sin slash al final).
  siteUrl: "https://www.car4u.mx",

  siteName: "CAR4U",

  // Título/descripción usados cuando una ruta no define los suyos propios.
  defaultTitle: "CAR4U | Autos Seminuevos Certificados con Garantía",
  titleTemplate: "%s | CAR4U",
  defaultDescription:
    "Compra tu auto seminuevo certificado en CAR4U. Miles de opciones, financiamiento a tu medida y garantía en motor y transmisión.",

  // Imagen usada como Open Graph / Twitter Card cuando la página no tiene una propia.
  // Vive en public/ (no en src/) para que Vite la copie tal cual a la raíz del
  // build, con una URL estable que no depende del hash de assets generado en
  // cada compilación. Se resuelve a URL absoluta en tiempo de ejecución (useSeoMeta).
  defaultImagePath: "/og-default.png",

  locale: "es_MX",
  language: "es",
  themeColor: "#069d25",

  twitterCardType: "summary_large_image",
  // twitterSite: "@car4u", // Descomenta y ajusta si existe una cuenta oficial de Twitter/X.

  organization: {
    name: "CAR4U",
    legalName: "CAR4U",
    telephone: "+52-449-455-1588",
    email: "atencionclientes@car4u.mx",
    whatsapp: "https://api.whatsapp.com/send?phone=4494551588",
    // Ruta pública y estable (sirve desde public/, sin hash) usada en el
    // JSON-LD de Organization/AutoDealer.
    logoPath: "/og-default.png",
    sameAs: [
      // Agrega aquí URLs de redes sociales oficiales, ej:
      // "https://www.facebook.com/car4umx",
      // "https://www.instagram.com/car4umx",
    ],
  },
};

export default seoConfig;
